export const FilterIcon = () => (
  <svg
    width="19"
    height="18"
    style={{ width: "19px", height: "18px" }}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 3H18" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="6" cy="3" r="2" fill="#294A59" stroke="white" />
    <path d="M1 15H18" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M1 9H18" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="13" cy="9" r="2" fill="#294A59" stroke="white" />
    <circle cx="5" cy="15" r="2" fill="#294A59" stroke="white" />
  </svg>
);
